import React, {useEffect, useState} from 'react';

import {AppProvider} from './app/AppContext';
import BoardComponent from './components/board/BoardComponent';
import BoardHeader from './components/board/BoardHeader';
import {SyncStatus} from './components/storage/SyncStatus';
import './App.css';
import {BoardFooter} from "./components/board/BoardFooter";
import {useSignal} from "./app/useSignal";
import {AppSignals} from "./app/AppSignals";
import {useForceUpdate} from "./app/useForceUpdate";
import {getInstallInfo, registerServiceWorker} from "./registerServiceWorker";
import PWAStatus from "./components/PWAStatus";
import {DeviceClass} from "./app/useDeviceDetection";
import BackButtonManager from "./components/backbutton/BackButtonManager";
import ToastManager from "./components/backbutton/ToastManager";
import "./components/backbutton/Toast.css";
import {App} from "./app/AppSingleton";


function PWAInstallPrompt(props: { onDismiss: () => void, onInstall: () => void }) {
	return null;
}

function startPWA()
{
	const [showInstallPrompt, setShowInstallPrompt] = useState(false);
	const [pwaInfo, setPwaInfo] = useState<any>(null);

	useEffect(() => {
		// Регистрируем Service Worker
		registerServiceWorker();

		// Получаем информацию о PWA
		const info = getInstallInfo();
		setPwaInfo(info);

		// Проверяем, нужно ли показывать промпт установки
		if (info.supportsPWA && !info.isInstalled) {
			// Проверяем, был ли уже отклонен промпт
			const promptDismissed = localStorage.getItem('pwaPromptDismissed');
			const promptShownCount = parseInt(localStorage.getItem('pwaPromptShownCount') || '0');

			if (!promptDismissed && promptShownCount < 3) {
				// Показываем промпт через 30 секунд после загрузки
				const timer = setTimeout(() => {
					setShowInstallPrompt(true);
					localStorage.setItem('pwaPromptShownCount', (promptShownCount + 1).toString());
				}, 30000);

				return () => clearTimeout(timer);
			}
		}
	}, []);

	const handleInstallPromptDismiss = () => {
		setShowInstallPrompt(false);
		// Сохраняем в localStorage, что пользователь отклонил промпт
		localStorage.setItem('pwaPromptDismissed', 'true');
	};

	const handleInstall = () => {
		console.log('PWA установлено');
		localStorage.setItem('pwaInstalled', 'true');
		localStorage.removeItem('pwaPromptDismissed');
		localStorage.removeItem('pwaPromptShownCount');
	};

	return <>
		<div className="app__pwa-status">
			<PWAStatus showDetails={false} />
		</div>

		{/* Промпт установки PWA */}
		{showInstallPrompt && (
			<PWAInstallPrompt
				onDismiss={handleInstallPromptDismiss}
				onInstall={handleInstall}
			/>
		)}
	</>
}
const AppComponent: React.FC = () => {
	let syncStatus = null;// <SyncStatus/>;
	const forceUpdate = useForceUpdate();
	// Подписка на инвалидацию приложения
	useSignal(AppSignals.appInvalidated, forceUpdate);

	let pwa = null;
	try {
		pwa = startPWA();
	}
	catch (e){
		console.warn(e);
	}
	let board = App.getInstance().getCurrentBoard();
	return (
		<AppProvider>
			<DeviceClass/>
			<BackButtonManager board={board} />
			<ToastManager />
			<div className="app">
				<div className="app__content">
					<BoardHeader board={board}/>
					<BoardComponent board={board}/>
					<BoardFooter>{pwa}</BoardFooter>
				</div>
				{syncStatus}
			</div>
		</AppProvider>
	);
};

export default AppComponent;
